// @ts-check

import { previewFile } from 'api';
import USER_INFO from 'constants/userInfoEnum';
import { checkObject } from 'libs/types/checkTypes';

/**
 * @typedef {Object} ConvertUserInfo_Param_Type
 * @property {number} UserId
 * @property {number} ContactId
 * @property {number} EmployeeId
 * @property {number} VFile
 * @property {string} Img
 * @property {number} CustomerId
 * @property {string} FirstName
 * @property {string} LastName
 * @property {string} FullName
 * @property {string} UserName
 * @property {string[]} Roles
 * @property {string[]} RolesV3
 * @property {Object[]} UserRoleGroups
 * @property {number} UserRoleGroups.Id
 * @property {string} UserRoleGroups.Name
 * @property {boolean} IntroCompleted
 * @property {string} PostLoginURL
 */

/**
 * @typedef {Object} ConvertUserInfo_Return_Type
 * @property {string} contactId
 * @property {string} userId
 * @property {string} employeeId
 * @property {string} username
 * @property {string} fullname
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} customerId
 * @property {string} vFile
 * @property {string} image
 * @property {Object[]} userRoleGroups
 * @property {string} userRoleGroups.id
 * @property {string} userRoleGroups.name
 * @property {string[]} roles
 * @property {string} postLoginURL
 */

/**
 * @function convertUserInfo
 * @param {ConvertUserInfo_Param_Type} obj
 * @returns {Promise<ConvertUserInfo_Return_Type>}
 * @throws {TypeError}
 */
async function convertUserInfo(obj) {
	checkObject(obj);

	let image = '';
	if (String(obj.VFile) !== '' && String(obj.VFile) !== '0') {
		const imgPath = await previewFile(String(obj.VFile));
		image = imgPath;
	}

	const userInfo = {
		[USER_INFO.CONTACT_ID]: String(obj.ContactId),
		[USER_INFO.USER_ID]: String(obj.UserId),
		[USER_INFO.EMPLOYEE_ID]: String(obj.EmployeeId),
		[USER_INFO.USERNAME]: obj.UserName,
		[USER_INFO.FULL_NAME]: obj.FullName,
		[USER_INFO.FIRST_NAME]: obj.FirstName,
		[USER_INFO.LAST_NAME]: obj.LastName,
		[USER_INFO.CUSTOMER_ID]: String(obj.CustomerId),
		[USER_INFO.V_FILE]: String(obj.VFile),
		[USER_INFO.IMAGE]: image,
		[USER_INFO.ROLE_GROUPS]: obj.UserRoleGroups.map((group) => ({
			[USER_INFO.ID]: String(group.Id),
			[USER_INFO.NAME]: group.Name,
		})),
		[USER_INFO.ROLES]: obj.RolesV3,
		[USER_INFO.ROLE_NAMES]: obj.Roles ?? [],
		[USER_INFO.INTRO_COMPLETED]: obj.IntroCompleted === true,
		[USER_INFO.POST_LOGIN_URL]: obj.PostLoginURL,
	};

	return userInfo;
}

export default convertUserInfo;
